import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaRegEnvelope } from 'react-icons/fa'
import { FaXTwitter } from 'react-icons/fa6'
import { FiPhone } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import ContactForm from './Forms/ContactForm'
import langData from '../locales/langData.json'
import { MdOutlineLocationOn } from 'react-icons/md'
import SEO from './SEO'

const Contact = ({ language }) => {
    const contact = langData[language].contact;
    const socialLinks = {
        linkedin: "https://www.linkedin.com/company/captainx",
        instagram: "https://www.instagram.com/captainx.ai",
        facebook: "https://www.facebook.com/CaptainXAI",
        twitter: "https://x.com/captainx_ai",
    };
    return (
        <>
            <SEO
                title="Contact CaptainX | Jeddah, Saudi Arabia"
                titleAr="تواصل مع كابتن اكس | جدة، المملكة العربية السعودية"
                description="Ready to transform your sports organisation? Contact CaptainX to help athletes, academies, and federations streamline operations, strategise, and scale."
                descriptionAr="هل أنت مستعد لتطوير مؤسستك الرياضية؟ تواصل معنا لمساعدة الرياضيين والأكاديميات والاتحادات الرياضية على تبسيط العمليات ووضع الاستراتيجيات وتوسيع نطاقها."
                path="/contact"
                language={language}
            />
          
        <section className='contact-sec py-5'>
            <div className="container">
                <div className="row pt-5">
                    <div className="col-md-5 form-line">
                       <div className="">
                         <h2 className="sec-title">{contact.contacttitle}</h2>
                        <p className="contact-p">{contact.contactdesc}</p>

                        <div className="row my-2">
                            <div className="col">
                                <Link to="mailto:info@captainx.ai" className='text-decoration-none'>
                                    <div className="card-contact">
                                        <FaRegEnvelope /><br />
                                        <h6>{contact.email}</h6>
                                        
                                        <p>info@captainx.ai</p>
                                    </div>
                                </Link>
                            </div>
                            <div className="col">
                                <Link to="tel:+966539872389" className='text-decoration-none'>
                                    <div className="card-contact">
                                        <FiPhone /><br />
                                        <h6>{contact.phone}</h6> 
                                        <p>+966 53 987 2389</p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="row my-2">
                            <div className="col-md-12">
                                <Link to="https://maps.app.goo.gl/cfYWixZt6QRjMKYk7" className='text-decoration-none'>
                                    <div className="card-contact">
                                        <MdOutlineLocationOn />
                            
                                        <h6>{contact.locations}</h6>
                                        <p>{contact.address}
                                        </p>
                                    </div>
                                </Link>
                            </div>
                        </div>
                       </div>
                        <div className="follow-part  pt-3">
                            <h6>{contact.follow}</h6>
                            <div className="social-icons">
                                <div className="icon">
                                    <Link to={socialLinks.linkedin}><FaLinkedinIn /></Link>
                                </div>
                                <div className="icon">
                                    <Link to={socialLinks.instagram}><FaInstagram /></Link>
                                </div>
                                <div className="icon">
                                    <Link to={socialLinks.facebook}><FaFacebookF /></Link>
                                </div>
                                <div className="icon">
                                    <Link to={socialLinks.twitter}><FaXTwitter /></Link>
                                </div>
                            </div>
                        </div>

                      
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 py-3">
                        <ContactForm language={language} />
                    </div>
                </div>
            </div>
        </section>
        </>
    )
}

export default Contact